import { useQuery } from '@tanstack/react-query';
import { clientWithAuth } from 'dashboard409a/services/base';
import {
  FulfillmentModelLeaderboardEntry,
  FulfillmentModelLeaderboardResponse,
} from 'dashboard409a/services/fulfillmentModelLeaderboard.types';

export const FulfillmentModelLeaderboardQueryKeys = {
  LEADERBOARD: 'fulfillment-model-leaderboard',
} as const;

export const fetchFulfillmentModelLeaderboard = async (
  signal?: AbortSignal
): Promise<FulfillmentModelLeaderboardResponse> => {
  const response = await clientWithAuth.get<FulfillmentModelLeaderboardResponse>(
    '/api/dashboard/user/models/leaderboard/',
    { signal }
  );
  return response.data;
};

export const getLeaderboardDisplayName = (entry: FulfillmentModelLeaderboardEntry): string => {
  const name = [entry.first_name, entry.last_name].filter(Boolean).join(' ').trim();
  return name || entry.email;
};

export const useFulfillmentModelLeaderboard = (enabled: boolean) =>
  useQuery({
    queryKey: [FulfillmentModelLeaderboardQueryKeys.LEADERBOARD],
    queryFn: ({ signal }) => fetchFulfillmentModelLeaderboard(signal),
    enabled,
    staleTime: 60 * 1000,
  });
